import React from 'react';
import { SVGProps } from '../../../types/svgs';

const VolksKlickLogoInner = ({
  className,
  title,
  ariaHidden,
  ariaLabel,
  tabIndex,
  color
}: SVGProps) => {
  return (
    <svg
      className={className}
      aria-hidden={ariaHidden}
      role={ariaHidden ? undefined : 'img'}
      tabIndex={tabIndex}
      aria-label={ariaLabel}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      fill={color ? color : "currentColor"}
      version="1.1"
      width="100%"
      height="100%"
      viewBox="0 0 243.45 194.9"
    >
      {title && <title>{title}</title>}
      <g xmlns="http://www.w3.org/2000/svg">
        <g>
          <path
            className="cls-1"
            d="m149.7,48.4l-9.8-.4c-2.1-3.5-4-6.5-5.4-8.7-.5-.7-.9-1.4-1.3-2-3.2-5-6-6.7-11.8-6.7h-41.6c-5.7.1-8.6,1.7-11.8,6.7-.4.6-.8,1.2-1.3,2-1.5,2.3-3.4,5.3-5.4,8.7l-9.8.4c-1.2,0-2.1.9-2.4,2.1s.4,2.3,1.5,2.7c.1.1,2.3.9,6.7,1.8-.4.7-.8,1.5-1.2,2.1-3,5.3-5.4,9.5-5.4,20.3v21.3c0,3.6,2.9,6.5,6.5,6.5h8.4c3.6,0,6.5-2.9,6.5-6.5v-3.7c18.9,1.3,38,1.3,56.9,0v3.7c0,3.6,2.9,6.5,6.5,6.5h8.4c3.6,0,6.5-2.9,6.5-6.5v-21.3c0-10.8-2.4-15-5.4-20.3-.4-.7-.8-1.4-1.2-2.1,4.5-.9,6.6-1.8,6.7-1.8,1.1-.5,1.7-1.6,1.5-2.7s-1.2-2.1-2.3-2.1Zm-78.7-6.5c.5-.8.9-1.4,1.3-2,2.3-3.6,3.6-4.4,7.6-4.4h41.5c4,0,5.3.8,7.6,4.4.4.6.8,1.3,1.3,2,1.5,2.4,3.6,5.6,5.7,9.2-.9.1-1.8.2-2.7.3-3.2.3-6.9.2-11.3.2h-42.7c-4.3,0-8.1.1-11.3-.2-1-.1-1.9-.2-2.7-.3,2.1-3.6,4.2-6.8,5.7-9.2Zm-10.5,17.7c.5-.9,1.1-1.9,1.7-3,.1-.3.3-.5.4-.8,1.5.2,3.2.4,5,.5,2.3.2,4.9.2,7.7.2h50.8c2.8,0,5.3,0,7.7-.2,1.8-.1,3.5-.3,5-.5.1.3.3.5.4.8.6,1.1,1.1,2,1.7,3,.1.1.1.2.2.4l-14.8,4.2c-.9.2-1.6,1-1.8,1.9l-.5,2.4h-17c-1.1-2.2-3.4-3.7-6.1-3.7s-4.9,1.5-6.1,3.7h-17.1l-.5-2.4c-.2-.9-.9-1.6-1.8-1.9l-14.8-4.2c-.2-.2-.2-.3-.1-.4Zm42,11.9c0,1-.8,1.8-1.8,1.8s-1.8-.8-1.8-1.8.8-1.8,1.8-1.8,1.8.8,1.8,1.8Zm-44.5-7l14.4,4.1.7,3.4-5,1.5-12-2.4c.4-2.7,1-4.7,1.9-6.6Zm87.4,13v21.3c0,.8-.7,1.5-1.5,1.5h-8.4c-.8,0-1.5-.7-1.5-1.5v-6.3c0-.7-.3-1.4-.8-1.8s-1.1-.7-1.7-.7h-.3c-20.4,1.5-41,1.5-61.4,0-.7-.1-1.4.2-1.9.7s-.8,1.1-.8,1.8v6.3c0,.8-.7,1.5-1.5,1.5h-8.4c-.8,0-1.5-.7-1.5-1.5v-22.6l12,2.4h.5c.2,0,.5,0,.7-.1l7.8-2.4c1.2-.4,1.9-1.5,1.7-2.6h15.6c.8,2.8,3.4,4.9,6.6,4.9s5.7-2.1,6.6-4.9h15.5c-.1,1.2.6,2.3,1.7,2.6l7.8,2.4c.2.1.5.1.7.1h.5l12-2.4c0,.3,0,.8,0,1.3Zm-.4-6.4l-12,2.4-5-1.5.7-3.4,14.4-4.1c.9,1.9,1.6,3.9,1.9,6.6Z"
          />
          <path
            className="cls-1"
            d="m242.7,180.3l-25.9-25.9,17.5-8.5c.9-.4,1.5-1.4,1.5-2.4s-.6-2-1.5-2.4l-33.2-15.3V7.5c0-4.1-3.4-7.5-7.5-7.5H7.5C3.4,0,0,3.4,0,7.5v120.7c0,4.1,3.4,7.5,7.5,7.5h159l8.6,18.5H2.6c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h174.8l12.3,26.6c.4.9,1.4,1.5,2.4,1.5h0c1,0,2-.6,2.4-1.5l8.4-17.6,25.9,25.9c.5.5,1.2.8,1.9.8s1.4-.3,1.9-.8l10.1-10.1c1-1,1-2.7,0-3.7ZM7.5,130.7c-1.4,0-2.5-1.1-2.5-2.5V7.5c0-1.4,1.1-2.5,2.5-2.5h186.1c1.4,0,2.5,1.1,2.5,2.5v116l-38.3-17.7c-1-.5-2.2-.3-3,.5s-1,2-.5,3l9.9,21.4H7.5Zm223.2,57.8l-26.7-26.7c-.5-.5-1.2-.8-1.9-.8h-.4c-.9.1-1.6.7-1.9,1.5l-7.6,15.9-30-64.8,64.8,30-15.8,7.6c-.8.4-1.3,1.1-1.5,2-.1.8.1,1.7.7,2.3l26.6,26.6-6.3,6.4Z"
          />
        </g>
      </g>
    </svg>
  );
};

export const VolksKlickLogo = React.forwardRef<SVGElement, SVGProps>(
  (props, forwardRef) => <VolksKlickLogoInner {...props} ref={forwardRef} ariaHidden />
);
